import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraText } from '@mono/ui-components';
import { SpecraEmptyState, SpecraInlineBanner, SpecraPageHeader, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../../contexts/authContext';
import { useRecordShellEnabled } from '../../../RecordShell/recordShellFlag';
import { CarriedInTable } from '../home/CarriedInTable';
import { useProposalCarriedIn } from '../home/useProposalCarriedIn';
import { SourcesPage } from './SourcesPage';
/** PRP-04: Sources → From the pursuit. Behind growth_record_shell_v1; off keeps the placeholder. */ export function SourcesPursuitPage() {
    const { id } = useParams();
    const { user } = useAuth();
    const shell = useRecordShellEnabled();
    if (!shell) return /*#__PURE__*/ _jsx(SourcesPage, {});
    if (!id || !user) return null;
    return /*#__PURE__*/ _jsx(PursuitBody, {
        projectId: id,
        principal: `${user.tenant_id}:${user.id}`
    });
}
function PursuitBody({ projectId, principal }) {
    const query = useProposalCarriedIn(principal, projectId, true);
    const data = query.data;
    const rows = data?.rows ?? [];
    const body = (()=>{
        if (query.isPending || query.isFetching || !query.isFetchedAfterMount) {
            return /*#__PURE__*/ _jsx("p", {
                "aria-busy": "true",
                children: "Loading what the pursuit carried in…"
            });
        }
        if (query.isError) {
            return /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "danger",
                role: "alert",
                children: "What the pursuit carried in could not be loaded. Retry or request Proposal access."
            });
        }
        if (!data?.pursuit) {
            return /*#__PURE__*/ _jsx(SpecraEmptyState, {
                title: "No pursuit behind this proposal",
                description: "This proposal was started directly, so nothing was carried in."
            });
        }
        if (rows.length === 0) {
            return /*#__PURE__*/ _jsx(SpecraEmptyState, {
                title: "Nothing carried in yet",
                description: "The pursuit has no hot buttons, win themes, past performance or other items to carry in."
            });
        }
        return /*#__PURE__*/ _jsx(CarriedInTable, {
            rows: rows,
            expanded: true
        });
    })();
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4 p-4 sm:p-6 lg:p-8",
        "data-testid": Testids.proposalCarriedIn.page,
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                titleSize: "ui",
                title: "From the pursuit",
                description: data?.pursuit?.name ? `What this proposal carried in from ${data.pursuit.name}.` : undefined
            }),
            data?.readOnly ? /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "neutral",
                children: "You can view what the pursuit carried in. Changing it needs Growth access."
            }) : null,
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Carried in",
                action: /*#__PURE__*/ _jsx(SpecraText, {
                    size: "meta",
                    children: "Nothing re-typed: each item links back to where it came from"
                })
            }),
            body
        ]
    });
}
